export const RAGE_QUIT_WIN_SCORE = 5;
export const RAGE_QUIT_LOSS_SCORE = 0;

export function buildRageQuitScoreFromWinner(winnerUid, player1Uid, player2Uid) {
  if (!winnerUid || !player1Uid || !player2Uid) {
    return { scoreP1: null, scoreP2: null };
  }

  if (String(winnerUid) === String(player1Uid)) {
    return { scoreP1: RAGE_QUIT_WIN_SCORE, scoreP2: RAGE_QUIT_LOSS_SCORE };
  }

  if (String(winnerUid) === String(player2Uid)) {
    return { scoreP1: RAGE_QUIT_LOSS_SCORE, scoreP2: RAGE_QUIT_WIN_SCORE };
  }

  return { scoreP1: null, scoreP2: null };
}

export function buildRageQuitScoreFromQuitter(quitterUid, player1Uid, player2Uid) {
  if (!quitterUid || !player1Uid || !player2Uid) {
    return { scoreP1: null, scoreP2: null };
  }

  if (String(quitterUid) === String(player1Uid)) {
    return { scoreP1: RAGE_QUIT_LOSS_SCORE, scoreP2: RAGE_QUIT_WIN_SCORE };
  }

  if (String(quitterUid) === String(player2Uid)) {
    return { scoreP1: RAGE_QUIT_WIN_SCORE, scoreP2: RAGE_QUIT_LOSS_SCORE };
  }

  return { scoreP1: null, scoreP2: null };
}
